if (!customElements.get("td-sort-select")) {
  class TdsortSelectMobile extends HTMLElement {
    constructor() {
      super();
      this.sortSelectMobile = null;
      this.sortLabelMobile = null;
      this.sortSelectDesktop = null;
      this.sortLabelDesktop = null;
    }

    connectedCallback() {
      this.sortSelectMobile = this.querySelector("#SortBy-mobile");
      this.sortLabelMobile = this.querySelector(".td-facets__sort-label-mb");
      this.sortSelectDesktop = this.querySelector("#SortBy");
      this.sortLabelDesktop = this.querySelector(".td-facets__sort-label-dsk");

      if (this.sortSelectMobile && this.sortLabelMobile) {
        this.sortSelectMobile.addEventListener("change", () => {
          this.updateLabel(this.sortSelectMobile, this.sortLabelMobile);
        });
        this.updateLabel(this.sortSelectMobile, this.sortLabelMobile); 
      }

      if (this.sortSelectDesktop && this.sortLabelDesktop) {
        this.sortSelectDesktop.addEventListener("change", () => {
          this.updateLabel(this.sortSelectDesktop, this.sortLabelDesktop);
        });
        this.updateLabel(this.sortSelectDesktop, this.sortLabelDesktop);
      }
    }

    updateLabel(sortSelect, sortLabel) {
      if (!sortSelect || !sortLabel) {
        return;
      }

      const selectedOption = sortSelect.options[sortSelect.selectedIndex]?.textContent;
      if (selectedOption) {
        sortLabel.textContent = selectedOption;
      }
    }
  }

  customElements.define("td-sort-select", TdsortSelectMobile);
}
